import * as gfunctions from '../../../js/generalFunctions';

CCL.addToCartSuccessModal = {
  autoload: [
    ['modalEvents', $('#addToCartSuccessModal').length > 0]
  ],

  modalEvents() {
    const modalEl = $('#addToCartSuccessModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-add-to-cart-success-modal/add-to-cart-success-modal.js